import Clipboard from "clipboard";
const initClipboard = () => {
    if(document.querySelector('.kirinus-share-link__copy-to-clipboard')){
        const clippy = new Clipboard('.kirinus-share-link__copy-to-clipboard', {

        });
        clippy.on('success', function(e){
            let html = document.createElement('div');
            html.classList.add('kirinus-clipboard-modal', 'success');
            html.innerHTML = '<p>Die Webadresse der Stellenanzeige wurde erfolgreich in die Zwischenablage kopiert!</p>';



            document.body.appendChild(html);

            fadeIn(html);

            setTimeout(() => {
                fadeOut(html);
            }, 4000);

            setTimeout(() => {
                html.remove();
            }, 6000);

            e.clearSelection();
        })
    }
    function fadeOut(el) {
        el.style.opacity = 1;
        (function fade() {
            if ((el.style.opacity -= .1) < 0) {
                el.style.display = "none";
            } else {
                requestAnimationFrame(fade);
            }
        })();
    };

    // ** FADE IN FUNCTION **
    function fadeIn(el, display) {
        el.style.opacity = 0;
        el.style.display = display || "block";
        (function fade() {
            var val = parseFloat(el.style.opacity);
            if (!((val += .1) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        })();
    };
}
export default initClipboard;